// import LazyLoad from "https://cdn.skypack.dev/vanilla-lazyload";
// new LazyLoad();

import "https://cdn.skypack.dev/pin/lazysizes@v5.3.2-WNy9BCv7TL53ruRqTQIK/mode=imports,min/optimized/lazysizes.js";
// import "https://cdn.skypack.dev/lazysizes/plugins/object-fit/ls.object-fit";
// import "https://cdn.skypack.dev/lazysizes/plugins/parent-fit/ls.parent-fit";
// import "https://cdn.skypack.dev/lazysizes/plugins/rias/ls.rias";
import "https://cdn.skypack.dev/pin/lazysizes@v5.3.2-WNy9BCv7TL53ruRqTQIK/mode=imports,min/unoptimized/plugins/bgset/ls.bgset.js";
// import "https://cdn.skypack.dev/lazysizes/plugins/respimg/ls.respimg";

import gtag from "//www.cluedupp.com/cdn/shop/t/122/assets/global-gtag.js?v=178421715114227603801680185824";
import klaviyo from "//www.cluedupp.com/cdn/shop/t/122/assets/global-klaviyo.js?v=90774599793273452201710339512";
import nzModal from "//www.cluedupp.com/cdn/shop/t/122/assets/global-modal-nz.js?v=159488986948011835181680185824";
import smoothscroll from "//www.cluedupp.com/cdn/shop/t/122/assets/global-smoothscroll.js?v=52019029063129676291710342508";
import {
  bindInPageLinks,
  focusHash,
} from "https://cdn.skypack.dev/pin/@shopify/theme-a11y@v4.1.1-FrBhjNQM2AF3co6myt8x/mode=imports,min/optimized/@shopify/theme-a11y.js";

focusHash();
bindInPageLinks();

function setCountryClass(code) {
  document.body.classList.add(`countrycode-${code}`);
}

async function checkUserLocation() {
  let countryCode = sessionStorage.getItem("countryCode");

  if (countryCode === null) {
    countryCode = await fetch("https://get.geojs.io/v1/ip/country")
      .then((response) => response.text())
      .then((code) => {
        countryCode = code.trim().toLowerCase();
        sessionStorage.setItem("countryCode", countryCode);

        return countryCode;
      })
      .catch((err) => console.error(err));
  }

  setCountryClass(countryCode);

  if (countryCode === "nz") {
    nzModal();
  }
}

const initCore = () => {
  checkUserLocation();
  klaviyo();
  gtag();
  smoothscroll();
};

document.addEventListener("DOMContentLoaded", () => {
  initCore();

  // Cookie check
  const cookies = document.querySelector(".ck-Cookies");
  const noCookies = document.querySelector(".ck-Cookies-none");

  if (cookies && noCookies) {
    if (!navigator.cookieEnabled) {
      noCookies.style.display = "block";
    }
  }

  // Scroll
  document.querySelectorAll("[data-scroll]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.querySelector(el.dataset.scroll);
      target.scrollIntoView({
        behavior: "smooth",
      });
    });
  });
});
